<div class="toolbar">
  <sui-button
    variant="secondary"
    [leadingIcon]="['fas', 'plus']"
    [disabled]="companyId === null"
    (click)="addMembers()"
  >
    {{ "user-group-members.button.add-members" | translate }}
  </sui-button>

  <div class="selected-members">
    @if (membersLoading) {
      {{
        "user-group-members.toolbar.selected-number-of-members"
          | translate: { count: 0, totalNumberOfMembers: 0 }
      }}
    } @else {
      {{
        "user-group-members.toolbar.selected-number-of-members"
          | translate
            : {
                count: (temporalSelectedMembersList$ | async)?.length || 0,
                totalNumberOfMembers: membersTotal,
              }
      }}
    }
  </div>
</div>

<div class="filters">
  @if (showFilters) {
    <sui-tabs
      [tabs]="filterTabs"
      [value]="filter"
      (valueChange)="fitlerItems($any($event))"
    ></sui-tabs>
  }
</div>

<div class="principals">
  @for (
    object of temporalSelectedMembersList$
      | async
      | generalFilter: searchString : ["name", "email"];
    track object
  ) {
    @if (showPrincipal(object)) {
      <app-principal-card
        [showDelete]="true"
        [highlightText]="searchString"
        [principal]="object"
        (onObjectDelete)="deletePrincipal(object)"
      ></app-principal-card>
    }
  }
</div>
